// useAddonMode — detecta si el funnel se inició desde /mi-cuenta para añadir
// una mascota a una suscripción existente.
//
// Activado por el query param ?addon=<subscriptionId>. Cuando está presente:
//   - P1 salta la pregunta de animal (asume perro) y pide solo el nombre.
//   - Step13 NO crea un nuevo cart; en su lugar llama a
//     addPetToSubscription(subscriptionId, ...) y redirige a /mi-cuenta.
//
// Persistencia: el subscriptionId se guarda en sessionStorage con la clave
// `myl_addon_subscription_id` para que sobreviva la navegación interna del
// funnel (React Router no pasa ?addon= a cada step). Cuando el usuario
// termina (redirect a /mi-cuenta) la sesión se pierde sola porque
// sessionStorage no sobrevive tabs nuevas.
//
// Prioridad: URL param > sessionStorage. Así si el usuario abre otro
// addon en la misma pestaña, el URL prevalece y actualiza la sesión.

const SESSION_KEY = 'myl_addon_subscription_id';

export interface AddonContext {
  isAddon: boolean;
  subscriptionId: string | null;
}

export function useAddonMode(): AddonContext {
  if (typeof window === 'undefined') {
    return { isAddon: false, subscriptionId: null };
  }

  const params = new URLSearchParams(window.location.search);
  const urlId = params.get('addon');

  if (urlId && urlId.length > 0) {
    try {
      sessionStorage.setItem(SESSION_KEY, urlId);
    } catch {
      // sessionStorage blocked (iframe, incógnito estricto) — no-op.
    }
    return { isAddon: true, subscriptionId: urlId };
  }

  try {
    const stored = sessionStorage.getItem(SESSION_KEY);
    if (stored && stored.length > 0) {
      return { isAddon: true, subscriptionId: stored };
    }
  } catch {
    // idem
  }

  return { isAddon: false, subscriptionId: null };
}

/** Limpia el addon activo de sessionStorage. Llamar cuando el flujo termina
 *  (éxito o cancelación explícita) para evitar que un refresh posterior
 *  en /mi-cuenta reactive el modo addon sin querer. */
export function clearAddonSession(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    // noop
  }
}
